'use client';

import { motion } from 'framer-motion';
import { Search, Filter, X, Star } from 'lucide-react';

const AgentFilters = ({
  searchTerm,
  setSearchTerm,
  specialization,
  setSpecialization,
  language,
  setLanguage,
  badgeFilter,
  setBadgeFilter,
  specializations,
  languages,
}) => {
  const clearFilters = () => {
    setSearchTerm('');
    setSpecialization('');
    setLanguage('');
    setBadgeFilter('');
  };

  const hasActiveFilters =
    searchTerm || specialization || language || badgeFilter;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.5 }}
      className='bg-white dark:bg-gray-800 rounded-xl shadow-lg p-4 max-w-5xl mx-auto mt-10'
    >
      <div className='flex flex-col md:flex-row gap-4'>
        {/* Search input */}
        <div className='relative flex-1'>
          <Search
            className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
            size={18}
          />
          <input
            type='text'
            placeholder='Search by agent name...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className='w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primarycolor focus:border-primarycolor dark:bg-gray-700 dark:text-white'
          />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm('')}
              className='absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200'
            >
              <X size={16} />
            </button>
          )}
        </div>

        {/* Specialization filter */}
        <div className='relative'>
          <Filter
            className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
            size={18}
          />
          <select
            value={specialization}
            onChange={(e) => setSpecialization(e.target.value)}
            className='pl-10 pr-8 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primarycolor focus:border-primarycolor appearance-none dark:bg-gray-700 dark:text-white'
          >
            <option value=''>All Specializations</option>
            {specializations.map((spec) => (
              <option key={spec} value={spec}>
                {spec}
              </option>
            ))}
          </select>
        </div>

        {/* Language filter */}
        <div className='relative'>
          <svg
            className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M2 12H22'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
          <select
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            className='pl-10 pr-10 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primarycolor focus:border-primarycolor appearance-none dark:bg-gray-700 dark:text-white'
          >
            <option value=''>All Languages</option>
            {languages.map((lang) => (
              <option key={lang} value={lang}>
                {lang}
              </option>
            ))}
          </select>
        </div>

        {/* Badge filter */}
        <div className='relative'>
          <Star
            className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
            size={18}
          />
          <select
            value={badgeFilter}
            onChange={(e) => setBadgeFilter(e.target.value)}
            className='pl-10 pr-8 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primarycolor focus:border-primarycolor appearance-none dark:bg-gray-700 dark:text-white'
          >
            <option value=''>All Agents</option>
            <option value='superagent'>SuperAgent</option>
            <option value='trubroker'>TruBroker™</option>
            <option value='both'>Both Badges</option>
          </select>
        </div>

        {/* Clear filters button */}
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className='px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors flex items-center justify-center'
          >
            <X size={16} className='mr-1' />
            Clear
          </button>
        )}
      </div>
    </motion.div>
  );
};

export default AgentFilters;
